import { motion, MotionProps } from 'framer-motion';
import { ButtonTheme, elementsButtonClasses, ElementsButtonProps } from '../../Button';
import clsx from 'clsx';
import { Icon } from '../../Icon';

export interface TagItemProps extends Pick<ElementsButtonProps, 'icon' | 'disabled' | 'label'> {
  className?: string;
  onRemove?: () => void;
  allowRemove?: boolean;
  motionProps?: MotionProps;
}

export default ({ icon, disabled, label, allowRemove, onRemove, className, motionProps }: TagItemProps) => {
  const theme: ButtonTheme = 'secondary';

  return (
    <motion.div
      className={clsx(
        className,
        'pointer-events-none w-max',
        elementsButtonClasses.theme(theme),
        elementsButtonClasses.size('small'),
        elementsButtonClasses.base({ disabled })
      )}
      {...motionProps}
    >
      {icon && <Icon icon={icon} className={clsx('!h-5 !w-5', elementsButtonClasses.iconTheme(theme))} />}
      <p
        className={clsx(
          elementsButtonClasses.label,
          '!font-medium',
          theme === 'secondary' && '!text-palette-100',
          icon && 'mt-[2px]'
        )}
      >
        {label}
      </p>
      {allowRemove && (
        <motion.button
          tabIndex={0}
          role="button"
          type="button"
          onClick={onRemove}
          disabled={disabled}
          whileTap={{ scale: 0.9 }}
          whileFocus={{ scale: 1.1 }}
          whileHover={{ scale: 1.1 }}
          className={disabled ? 'pointer-events-none' : 'pointer-events-auto'}
        >
          <Icon icon="cancel" className="w-5 h-5 text-palette-600/80" />
        </motion.button>
      )}
    </motion.div>
  );
};
